import { vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["onload"];
const _hoisted_2 = ["sizes", "srcset", "onload"];
const _hoisted_3 = ["alt", "sizes", "srcset", "src", "width", "height", "onload", "draggable", "loading", "fetchpriority"];
const _hoisted_4 = ["onload"];
const _hoisted_5 = ["alt", "sizes", "srcset", "src", "draggable", "width", "height", "onload"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_inner_loading = _resolveComponent("q-inner-loading");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass({
            'self-center': _ctx.centered
        }),
        onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.$emit('click')))
    }, [
        _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["bg-transparent image-cover-load", {
                    ..._ctx.loadClass,
                    ..._ctx.picClass,
                    'absolute': _ctx.imagesLoaded,
                    'transparent': _ctx.imagesLoaded
                }]),
            style: _normalizeStyle(_ctx.parsedPicStyle)
        }, [
            _withDirectives(_createElementVNode("div", {
                class: _normalizeClass({
                    ..._ctx.picClass,
                    ..._ctx.loadClass,
                }),
                style: _normalizeStyle(_ctx.imageStyle)
            }, null, 6), [
                [_vShow, !_ctx.showLoad]
            ]),
            _createVNode(_component_q_inner_loading, {
                showing: _ctx.showLoad,
                class: "bg-transparent text-accent"
            }, null, 8, ["showing"])
        ], 6), [
            [_vShow, !_ctx.imagesLoaded]
        ]),
        (_ctx.allowOtherFormats)
            ? (_openBlock(), _createElementBlock("picture", {
                key: 0,
                class: _normalizeClass([{
                        ..._ctx.picClass,
                        'white-dark-background': _ctx.whiteBg,
                        'bg-transparent': !_ctx.whiteBg,
                        'absolute': !_ctx.imagesLoaded,
                        'transparent': !_ctx.imagesLoaded,
                        'crisp-images': _ctx.isChrome
                    }, "image-cover"]),
                style: _normalizeStyle(_ctx.parsedPicStyle),
                onload: _ctx.imageLoad(),
                onLoad: _cache[4] || (_cache[4] = ($event) => (_ctx.imageLoad()))
            }, [
                (_ctx.parsedWebpSrcSet)
                    ? (_openBlock(), _createElementBlock("source", {
                        key: 0,
                        type: "image/webp",
                        sizes: _ctx.sizes,
                        srcset: _ctx.parsedWebpSrcSet,
                        class: _normalizeClass({
                            ..._ctx.picClass,
                            'crisp-images': _ctx.isChrome
                        }),
                        style: _normalizeStyle(_ctx.imageStyle),
                        onError: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.checkError && _ctx.checkError(...args))),
                        onload: _ctx.imageLoad(),
                        onLoad: _cache[1] || (_cache[1] = ($event) => (_ctx.imageLoad()))
                    }, null, 46, _hoisted_2))
                    : _createCommentVNode("", true),
                _createElementVNode("img", {
                    alt: _ctx.alt || 'Space Image',
                    sizes: _ctx.sizes,
                    srcset: _ctx.parsedOriginalSrcSet,
                    src: _ctx.parsedOriginalSrc,
                    class: _normalizeClass({
                        ..._ctx.picClass,
                        'crisp-images': _ctx.isChrome
                    }),
                    style: _normalizeStyle(_ctx.imageStyle),
                    width: _ctx.widthHeightCalc.width,
                    height: _ctx.widthHeightCalc.height,
                    onError: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => (_ctx.checkError && _ctx.checkError(...args))),
                    onload: _ctx.imageLoad(),
                    onLoad: _cache[3] || (_cache[3] = ($event) => (_ctx.imageLoad())),
                    draggable: _ctx.isDraggable,
                    ref: "imageRef",
                    loading: _ctx.defaultLoaded
                        ? 'eager'
                        : 'lazy',
                    fetchpriority: _ctx.defaultLoaded
                        ? 'high'
                        : 'low'
                }, null, 46, _hoisted_3)
            ], 46, _hoisted_1))
            : (_openBlock(), _createElementBlock("picture", {
                key: 1,
                class: _normalizeClass({
                    ..._ctx.picClass,
                    'white-dark-background': _ctx.whiteBg,
                    'bg-transparent': !_ctx.whiteBg,
                    'absolute': !_ctx.imagesLoaded,
                    'transparent': !_ctx.imagesLoaded
                }),
                style: _normalizeStyle(_ctx.parsedPicStyle),
                onload: _ctx.imageLoad(),
                onLoad: _cache[7] || (_cache[7] = ($event) => (_ctx.imageLoad()))
            }, [
                _createElementVNode("img", {
                    alt: _ctx.alt || 'Space Image',
                    sizes: _ctx.sizes,
                    srcset: _ctx.parsedOriginalSrcSet,
                    src: _ctx.parsedOriginalSrc,
                    class: _normalizeClass(_ctx.picClass),
                    style: _normalizeStyle(_ctx.imageStyle),
                    draggable: _ctx.isDraggable,
                    width: _ctx.widthHeightCalc.width,
                    height: _ctx.widthHeightCalc.height,
                    onError: _cache[5] || (_cache[5] =
                        //@ts-ignore
                        (...args) => (_ctx.checkError && _ctx.checkError(...args))),
                    onload: _ctx.imageLoad(),
                    onLoad: _cache[6] || (_cache[6] = ($event) => (_ctx.imageLoad())),
                    ref: "imageRef"
                }, null, 46, _hoisted_5)
            ], 46, _hoisted_4))
    ], 2));
}
